import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ViewChild, SimpleChanges } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { IScan } from '../import-scans-util';
import { map } from 'rxjs/operators';
import { ButtonInfo } from 'src/app/common/UI-Components/helperClasses/value-and-display.class';
import { PointCloudSvc } from 'src/app/services/api.services/point-cloud.service';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { FormsModule } from '@angular/forms';
import { AsyncPipe, DecimalPipe, DatePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { SelectionBoxComponent } from '../../../../UI-Components/selection-box/selection-box.component';
import { PerfectScrollbarModule } from 'perfect-scrollbar-angular';
import { MatCheckbox } from '@angular/material/checkbox';
import { TooltipDirective } from '../../../../../Directives/tooltip.directive';

@Component({
    selector: 'ins-import-scans-scan-grid',
    templateUrl: './import-scans-scan-grid.component.html',
    styleUrls: ['./import-scans-scan-grid.component.scss',
        './../../../../UI-Components/shared-UI-components.scss',
        './../../../../../Viewer/content.container/side-bar.container/subMenus/submenus-shared-design.scss'],
    imports: [FormsModule, MatIcon, SelectionBoxComponent, PerfectScrollbarModule, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCheckbox, MatCellDef, MatCell, MatSortHeader, TooltipDirective, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, AsyncPipe, DecimalPipe, DatePipe]
})
export class ImportScansScanGridComponent implements OnChanges, OnInit {
  displayedScanColumns: string[] = ['select', 'name', 'x', 'y', 'z', 'modifiedAt', 'createdAt'];
  scanDataSource: MatTableDataSource<IScan>;
  scanFilterStr: string = '';
  selection = new SelectionModel<IScan>(true, []);
  filteredDataCount: number;
  noData;
  @Input('showLoading') showLoading = false;
  @Input('scansToShow') scansToShow: IScan[]
  @Output() scanSelectionChanged: EventEmitter<any> = new EventEmitter();
  @Output() resolutionChanged: EventEmitter<any> = new EventEmitter();

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  public resolutions: ButtonInfo[] = [];
  public defaultResolution: string;

  constructor(private readonly pointCloudSvc: PointCloudSvc) { }

  ngOnInit(): void {
      this.resolutions = this.pointCloudSvc.getResoultionOptions();
      this.defaultResolution = this.pointCloudSvc.getDefaultResolution();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    this.selection.clear();
    if ( changes.scansToShow ) {
      this.scanDataSource = new MatTableDataSource(this.scansToShow);
      this.scanDataSource.sort = this.sort;
      this.noData = this.scanDataSource.connect().pipe(map(data => data.length === 0));

      this.scanDataSource.data.forEach(row => this.selection.select(row));
      this.scanSelectionChanged.emit(this.selection.selected);
    }
  }

  resolutionValueChanged(resolution: string): void {
    this.resolutionChanged.emit(resolution);
  }

  scanFilterChanged(filterValue: string): void {
    this.scanDataSource.filter = filterValue.trim().toLowerCase();
    this.filteredDataCount = this.scanDataSource.filteredData.length;
  }

  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.scanDataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle(): void {
    this.isAllSelected() ?
        this.selection.clear() :
        this.scanDataSource.data.forEach(row => this.selection.select(row));
  }

  selectionChange(event: MouseEvent, row: IScan): void {
    if (event) {
      this.selection.toggle(row);
    }
    this.updateSelectionToParent();
  }

  masterSelectionChange(event: MouseEvent): void {
    if(event){
      this.masterToggle();
    }
    this.updateSelectionToParent();
  }

  updateSelectionToParent(): void {
    this.scanSelectionChanged.emit(this.selection.selected);
  }

  getToolTipConf(element: any, label: string): any {
    const toolTipConf = {text: '', position: { H: 'hLeft', V:'vBottom' }, type: 'info'};
    if ( element.offsetWidth < element.scrollWidth )  {
      toolTipConf.text = label;
    }
    return toolTipConf;
  }

  clearFilterStr(): void {
    this.scanFilterStr = '';
    this.scanFilterChanged('');
  }

}
